import gsap from 'gsap'
import axios from 'axios'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)
export default function job(){


  if(window.innerWidth > 1119){
    const pin = document.getElementById('jobLocalNav')
    const wrap = document.getElementById('jobContent')
    const head = document.getElementById('site-header')
    if(pin && wrap){
      ScrollTrigger.create({
        trigger: wrap,
        pin: pin,
        start: "top top",
        end: () => "+=" + (wrap.offsetHeight - pin.offsetHeight - head.offsetHeight),
        scrub: 1,
        invalidateOnRefresh: true,
        pinnedContainer: wrap,
        onEnter: () => pin.classList.add('active'),
        onLeaveBack: () => pin.classList.remove('active'),
      })
    }
    gsap.utils.toArray('.content__item__data__list').forEach((el, index) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top center",
        end: "bottom center",
        scrub: 1,
        invalidateOnRefresh: true,
        //markers: true,
        onEnter: () => setData(index),
        onEnterBack: ()=> setData(index),
      })
    })
  }


  document.querySelectorAll('.jobListContentModal').forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault() // ページ遷移を防止

      let modalOverlay = document.createElement('div')
      modalOverlay.classList.add('modal-overlay')
      document.body.appendChild(modalOverlay)

      let apiUrl = this.getAttribute('data-url')

      axios.get(apiUrl)
        .then(function(response) {
          let modalContent = document.createElement('div')
          modalContent.classList.add('modal-content')

          let modalContentInner = document.createElement('div')
          modalContentInner.classList.add('modal-content-inner')
          modalContentInner.classList.add('modal-content-inner--job')

          // タイトルを追加
          let titleElement = document.createElement('h2')
          titleElement.textContent = response.data.title.rendered
          modalContentInner.appendChild(titleElement)

          // 画像を追加
          let imgElement = document.createElement('img')
          imgElement.src = response.data._embedded['wp:featuredmedia'][0].source_url
          modalContentInner.appendChild(imgElement)

          // 説明を追加
          let descElement = document.createElement('div')
          descElement.innerHTML = response.data.content.rendered
          modalContentInner.appendChild(descElement)

          let closeButton = document.createElement('div')
          closeButton.classList.add('modal-content-btn')
          closeButton.textContent = '×'
          closeButton.addEventListener('click', function() {
            modalOverlay.remove()
          })

          modalContent.appendChild(closeButton)
          modalContent.appendChild(modalContentInner)
          modalOverlay.appendChild(modalContent)
        })
        .catch(function(error) {
          console.error('Error fetching modal content:', error)
        })
    })
  })

  
}

function setData(index){
  const elem = document.querySelectorAll('#jobLocalNav li')
  elem.forEach((el) => {
    el.classList.remove('active')
  })
  elem[index].classList.add('active')
}